/**
 * PATH: apps/qa/src/pages/area-execution/useSwipeGestures.ts
 * PURPOSE: Touch swipe gesture hook for mobile pass/fail actions
 */

import { useState, useCallback, useRef } from 'react'

export function useSwipeGestures(onSwipeLeft: () => void, onSwipeRight: () => void, threshold = 80) {
  const touchStart = useRef<{ x: number; y: number } | null>(null)
  const [swipeOffset, setSwipeOffset] = useState(0)

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStart.current = { x: e.touches[0].clientX, y: e.touches[0].clientY }
  }, [])

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    if (!touchStart.current) return
    const deltaX = e.touches[0].clientX - touchStart.current.x
    const deltaY = e.touches[0].clientY - touchStart.current.y
    if (Math.abs(deltaX) > Math.abs(deltaY) * 2) setSwipeOffset(deltaX)
  }, [])

  const handleTouchEnd = useCallback(() => {
    if (swipeOffset > threshold) onSwipeRight()
    else if (swipeOffset < -threshold) onSwipeLeft()
    setSwipeOffset(0)
    touchStart.current = null
  }, [swipeOffset, threshold, onSwipeLeft, onSwipeRight])

  return {
    swipeOffset,
    handlers: { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd },
  }
}
